import { Table, Status, CopyButton, HeadItemType } from 'components'
import { DraftProps } from 'container/Home/components/Banners/interface'
import { Dispatch, SetStateAction, useState } from 'react'
import SalesOrderMenu from './SalesOrderMenu'
import { URL_CONST } from 'constants/urls'
import * as S from './styles'
import CheckedDraftVerification from './CheckedDraftVerification'
import ModalDuplicate from 'container/SalesOrder/components/ModalDuplicate'
import ModalPostOn, {
  ClientsListInterface
} from 'container/SalesOrder/components/ModalPostOn'
import { useDispatch, useSelector } from 'store/store'
import { toast } from 'react-toastify'
import {
  setCheckedRecords,
  setDuplicateOrder
} from 'store/SalesOrderContext/salesOrderSlice'
import * as DraftOV from 'services/draft'
import { useNavigate } from 'react-router-dom'
import {
  FormatBodyType,
  getOrderStatus,
  getNegDifRowIcon,
  getPostOnBody,
  getHavaRowIcon,
  getEDIRowIcon
} from 'container/ManageOrders/utils'

type ViewBySalesOrderProps = {
  setDraftsData: Dispatch<SetStateAction<DraftProps[]>>
  draftsData: DraftProps[]
  getOrdersData: (body?: FormatBodyType) => Promise<void>
  draftsPage: number
}

const ViewBySalesOrder = ({
  setDraftsData,
  getOrdersData,
  draftsData,
  draftsPage
}: ViewBySalesOrderProps) => {
  const dispatch = useDispatch()
  const { draftBody, duplicateOrder } = useSelector(({ salesOrder }) => salesOrder)
  const [modalPostOn, setModalPostOn] = useState(false)
  const [modalDuplicate, setModalDuplicate] = useState(false)
  const [selectedDraft, setSelectedDraft] = useState('')
  const navigate = useNavigate()

  const setOrderSelection = (checked: boolean, id?: string) => {
    if (id) {
      const nrPedido = id.split('+')[0]

      const updatedDraftData = draftsData.map((draft) =>
        draft.NumeroPedidoRascunho === nrPedido ? { ...draft, checked } : draft
      )
      setDraftsData(updatedDraftData)
    } else {
      const updatedDraftData = draftsData.map((draft) => ({ ...draft, checked }))
      setDraftsData(updatedDraftData)
    }
  }

  const headTable: HeadItemType[] = [
    { label: 'Status', columnName: 'Status' },
    { label: 'Pedido Portal', columnName: 'NumeroPedido' },
    { label: 'Pedido Cliente', columnName: 'NumeroPedidoCliente' },
    { label: 'Razão social', columnName: 'RazaoSocial' },
    { label: 'Saldo Atendido', columnName: 'SaldoAtendido' },
    { label: 'Total de OVs', columnName: 'TotalOVs' },
    { label: 'Mat. Aberto', columnName: 'MatAberto' },
    { label: '', columnName: '' }
  ]

  const closePostOn = () => {
    setModalPostOn(false)
  }

  const handlePostOn = async (array: ClientsListInterface[]) => {
    const body = getPostOnBody(array, draftBody, selectedDraft)

    const post = await DraftOV.duplicateDraftOV(body)

    if (post) {
      closePostOn()
      getOrdersData({ page: draftsPage })
    }
    dispatch(setCheckedRecords([]))
  }

  const handleDuplicateOrder = async () => {
    await DraftOV.duplicateDraftOV(duplicateOrder).then((response) => {
      if (response) {
        navigate(`${URL_CONST.ORDERS}/${response[0]?.NumeroPedido?.trim()}`)
        //TODO: Debito técnico para o reload... verificar melhor forma de fazer isso
        window.location.reload()
      } else {
        toast.error('Erro ao duplicar pedido.')
      }
    })

    setDuplicateOrder({ ...duplicateOrder, Clientes: [] })
  }

  return (
    <>
      <CheckedDraftVerification
        draftsData={draftsData}
        getOrdersData={getOrdersData}
        draftsPage={draftsPage}
      />
      <Table
        hasCheckbox
        setChecked={setOrderSelection}
        headData={headTable}
        bodyData={draftsData.map((draft) => {
          const ovsNegDifInfo = draft.OrdensVendas
            ? draft.OrdensVendas.map((ov) => ({
                flag: ov.fl_negc_difd,
                isJustified: ov.dt_just_negc_difd,
                ovStatus: ov.cd_stat_orde_vend
              }))
            : undefined
          return {
            id: `${draft.NumeroPedidoRascunho}`,
            checked: draft.checked,
            linkNavigate: `${URL_CONST.MANAGE_ORDER}/${draft.NumeroPedidoRascunho}`,
            statusOrder: draft.CodigoStatusPedido,
            colunsNotNavigate: [7],
            content: [
              <Status
                key={`status-${draft.NumeroPedidoRascunho}`}
                status={getOrderStatus(draft)}
                label={draft.DescricaoStatusPedido}
              />,
              <S.TableInfo key={`number-${draft.NumeroPedidoRascunho}`}>
                <S.Flex>
                  {draft.NumeroPedidoRascunho}
                  <CopyButton text={draft.NumeroPedidoRascunho} />
                  {getNegDifRowIcon(ovsNegDifInfo)}
                  {getHavaRowIcon(draft.Origem)}
                  {getEDIRowIcon(draft.Origem, draft.StatusEDI)}
                </S.Flex>
                <span>Solicitado em {draft.DataCriacaoPedido}</span>
              </S.TableInfo>,
              <S.TableInfo key="number-client-order">
                <S.Flex>
                  {draft.NumeroPedidoCliente || (
                    <S.UnavailableInfo>Não informado</S.UnavailableInfo>
                  )}
                </S.Flex>
              </S.TableInfo>,
              <S.TableInfo key={`client-${draft.NumeroPedidoRascunho}`}>
                {draft.NomeCliente}
                <span>Código SAP: {draft.CodigoCliente}</span>
              </S.TableInfo>,
              draft.QuantidadeTotalAtendida,
              draft.OrdensVendas.length ? draft.OrdensVendas.length : '--',
              draft.QuantidadeTotalNaoAtendida,
              <SalesOrderMenu
                key={`action-more-${draft.NumeroPedidoRascunho}`}
                draft={draft}
                getOrdersData={getOrdersData}
                draftsPage={draftsPage}
                setSelectedDraft={setSelectedDraft}
                selectedDraft={selectedDraft}
                setModalDuplicate={setModalDuplicate}
                setModalPostOn={setModalPostOn}
                modalDuplicate={modalDuplicate}
              />
            ]
          }
        })}
      />
      <ModalPostOn
        open={modalPostOn}
        setOpen={setModalPostOn}
        orderNumber={selectedDraft}
        handlePostOn={handlePostOn}
        handleCancel={closePostOn}
      />
      {duplicateOrder?.nr_pedi_rasc_orig && (
        <ModalDuplicate
          open={modalDuplicate}
          setOpen={() => setModalDuplicate(!modalDuplicate)}
          handleDuplicated={handleDuplicateOrder}
        />
      )}
    </>
  )
}

export default ViewBySalesOrder
